class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.searchButtons = this.querySelectorAll('.search-Button');
    
    // Check if this search element is in the mobile menu drawer
    this.isMobileSearch = this.closest('.snippet-menu-drawer') !== null;
    
    // Only apply new functionality to mobile search
    if (this.isMobileSearch) {
      this.initializeMobilePlaceholder();
      this.initializeMobileSearchButton();
      this.addMobileEventListeners();
    } else {
      // Keep original functionality for desktop
      this.addDesktopEventListeners();
    }
  }
  
  initializeMobilePlaceholder() {
    const defaultPlaceholder = this.input.getAttribute('data-default-placeholder') || 'Search…';
    const focusPlaceholder = this.input.getAttribute('data-focus-placeholder') || 'Type here…';
    
    if (!this.input.placeholder || this.input.placeholder === '') {
      this.input.placeholder = defaultPlaceholder;
    }
  }
  
  initializeMobileSearchButton() {
    this.searchButtons.forEach(button => {
      button.disabled = true;
    });
  }
  
  addMobileEventListeners() {
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      this.updateMobileSearchButtonState();
    }, 300).bind(this));
    
    this.input.addEventListener('focus', this.handleMobileFocus.bind(this));
    this.input.addEventListener('blur', this.handleMobileBlur.bind(this));
    this.input.addEventListener('keypress', this.handleMobileKeyPress.bind(this));
  }
  
  addDesktopEventListeners() {
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if(input_length > 0){
        this.searchButtons.forEach(function(SearchButtons){
          SearchButtons.disabled = false;
        });
      } else {
        this.searchButtons.forEach(function(SearchButtons){
          SearchButtons.disabled = true;
        });
      } 
    }, 300).bind(this));
  }
  
  handleMobileFocus() {
    const focusPlaceholder = this.input.getAttribute('data-focus-placeholder') || 'Type here…';
    this.input.placeholder = focusPlaceholder;
  }
  
  handleMobileBlur() {
    if (this.input.value.trim() === '') {
      const defaultPlaceholder = this.input.getAttribute('data-default-placeholder') || 'Search…';
      this.input.placeholder = defaultPlaceholder;
    }
  }
  
  handleMobileKeyPress(event) {
    if (event.key === 'Enter' && this.input.value.trim().length > 0) {
      event.preventDefault();
      this.performMobileSearch();
    }
  }
  
  updateMobileSearchButtonState() {
    const hasContent = this.input.value.trim().length > 0;
    this.searchButtons.forEach(button => {
      button.disabled = !hasContent;
    });
  }
  
  performMobileSearch() {
    if (this.input.value.trim().length > 0) {
      this.querySelector('form').submit();
    }
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=5&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    })
    .then((text) => {
      const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      this.open();
      if(typeof quickAddButton == 'function'){
        quickAddButton();
      }
      if(document.getElementById('SearchValue')){
        document.getElementById('SearchValue').value = searchTerm;
      }           
    })
    .catch((error) => {
      this.close();
      throw error;
    });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    document.querySelector("body").classList.add("predective-search-active")
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
    document.querySelector("body").classList.remove("predective-search-active")
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}`);

const showDialog = () => {
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  const body = document.body;
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}px`;
  var Height_announce = 0;
  var announcementBAr_main = document.querySelector("#shopify-section-announcement-bar");
  if(announcementBAr_main){
    Height_announce = announcementBAr_main.clientHeight;
  }
  if(scrollY == "0"){
    document.querySelector(".section-header").style.top = Height_announce+'px';
  } else {
    document.querySelector(".section-header").style.top = "0";
  }
};

const closeDialog = () => {
  const body = document.body;
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
  document.querySelector(".section-header").style.top = "0";
}

var topScroll;
window.addEventListener('scroll', () => {
  document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}`);
  topScroll = document.documentElement.style.getPropertyValue('--scroll-y');
  if(window.scrollY > 0){
    var Top_HeighT = document.querySelector(".section-header").clientHeight;
    document.querySelector(".snippet-menu-drawer").style.top = Top_HeighT + "px";
    document.querySelector(".snippet-menu-drawer").style.height = "calc(100% - "+Top_HeighT+"px)";
    document.querySelector(".wish_list_message").style.top = Top_HeighT + "px";
    document.querySelector('.add_cart_message').style.top = "61px"
  } else {
    document.querySelector('.add_cart_message').style.top = "0"
  }
});

customElements.define('predictive-search', PredictiveSearch);

document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  var Announce_height = 0;
  var announcementBAr = document.querySelector("#shopify-section-announcement-bar");
  if(announcementBAr){
    Announce_height = announcementBAr.clientHeight;
  }
  var TOp_Height = document.querySelector(".section-header").clientHeight;
  var total_height = Announce_height + TOp_Height;
  var scroll_top_height = total_height;
  document.querySelector(".snippet-menu-drawer").style.top = total_height + "px";
  document.querySelector(".snippet-menu-drawer").style.height = "calc(100% - "+total_height+"px)";
  
  menuBurger.addEventListener('click',function(e){
    const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
    var Announce_height = 0;
    var announcementBAr = document.querySelector("#shopify-section-announcement-bar");
    if(announcementBAr){
      Announce_height = announcementBAr.clientHeight;
    }
    var TOp_Height = document.querySelector(".section-header").clientHeight;
    var total_height = Announce_height + TOp_Height;
    var scroll_top_height = total_height;
    if(scrollY == "0"){
      total_height = scroll_top_height;
    } else {
      var TOp_Height = document.querySelector(".section-header").clientHeight;
      total_height = TOp_Height;
    }
    document.querySelector(".snippet-menu-drawer").style.top = total_height + "px";
    document.querySelector(".snippet-menu-drawer").style.height = "calc(100% - "+total_height+"px)";
    document.querySelector(".wish_list_message").style.top = total_height + "px";
    document.querySelectorAll(".navmobile-dropdown").forEach(function(evtt){
      var totalHEOGHTKP = total_height+"px";
    })
    this.classList.toggle("active")
    document.querySelector('body').classList.toggle('open-menu');
    document.querySelector('html').classList.toggle('open-menu');
    document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter');
    if(document.querySelector('body').classList.contains('open-menu')){
      showDialog()
    } else {
      closeDialog()
    }
  });
});

document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});

document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu');
});

if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    document.querySelectorAll('.variant-grid').forEach(function(sizeList){
      sizeList.addEventListener('click',function(e){
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1
          }]
        };
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((data) => {
          if(data.status == 422){
            error_grid.innerHTML = data.description;
            setTimeout(function(e){
              error_grid.innerHTML = '';
            },2000);
          } else {          
            if(document.location.href.indexOf('/cart') > -1){
              window.location.href = "/cart";
            } else {
              if(typeof load_cart == 'function'){
                load_cart();
                setTimeout(function(e){
                  document.querySelector('body').classList.add('open-drawer');
                },500);
              } else {
                window.location.href = "/cart";
              }          
            }
            const url = '/cart.js';
            fetch(url)
            .then((resp) => resp.json())
            .then(function(data) {
              var cart_count = data.item_count;
              if(cart_count > 0){
                document.querySelector('.cart-count').innerHTML = cart_count;
              } else {
                document.querySelector('.cart-count').innerHTML = '';
              }
            })
            .catch(function(error) {
              console.log(error);
            })
          }
        })
        .catch((error) => {
          console.error(error);
        });
      });
    });
  }
  quickAddButton();
}

if(document.querySelector('.nav-arrow')){
  document.querySelectorAll('.nav-arrow').forEach(function(navArrow){
    navArrow.addEventListener('click',function(e){
      navArrow.closest('li').classList.toggle('active');
      this.parentElement.parentElement.parentElement.parentElement.parentElement.classList.add("subdrawer-active");      
    });
  });
}

if(document.querySelector('.list-menu')){
  document.querySelectorAll('.list-menu > li.mega-list').forEach(function(navList){
    navList.addEventListener('mouseover', function(){
      navList.classList.add('active');
      document.body.classList.add("active-megamenu");
    });
    navList.addEventListener('mouseout', function(){
      navList.classList.remove('active');
      document.body.classList.remove("active-megamenu");
    });
  });
}

document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search');
  }
};

if(window.innerWidth > 768){
  if(document.querySelector(".brand-filter-loist")){
    document.querySelector(".brand-filter-loist").classList.add("active"); 
  }
}

var get_search_icon = document.querySelector(".search-Button_forshow");
get_search_icon.addEventListener('click',function(e){
  e.preventDefault();
  document.getElementById("Search").style.display="block";
  document.querySelector(".snippet-search-bar").querySelector(".search-icon").style.right="16px";
  this.parentElement.parentElement.parentElement.style.width="300px";
  document.getElementById("Search").focus();
});

document.body.addEventListener("click", function (evt) {
  var get_search_icon = document.querySelector(".search-Button_forshow").querySelector("svg");
  var SearchInput = document.getElementById("Search");
  if(evt.target == SearchInput || evt.target == get_search_icon){
    document.querySelector(".snippet-search-bar").querySelector(".search-icon").style.right="16px";
    document.getElementById("Search").style.display="block";
  } else {
    document.querySelector(".snippet-search-bar").querySelector(".search-icon").style.right="0";
    document.getElementById("Search").style.display="none";
  }
});

if(window.innerWidth < 992){
  var footerAccordionParent = document.querySelectorAll(".footer-navigation");
  footerAccordionParent.forEach(function(e){
    e.addEventListener("click",function(){
      var ULIST = this.querySelector("ul");
      if(ULIST.classList.contains("accorion_active")){
        this.querySelector("ul").style.height = "0px"
        this.querySelector("h6").classList.remove("rotate_active");
        this.querySelector("ul").addEventListener('transitionend', () => {
          this.querySelector("ul").classList.remove('accorion_active')
        }, {once: true})
      } else {
        this.querySelector("ul").style.height = "auto";
        this.querySelector("ul").classList.add("accorion_active");
        this.querySelector("h6").classList.add("rotate_active");
        var Accordion_height = this.querySelector("ul").clientHeight + "px";
        this.querySelector("ul").style.height = "0px"
        setTimeout(() => {
          this.querySelector(".accorion_active").style.height = Accordion_height;
        }, 0) 
      }
    });
  })
}

document.querySelectorAll(".megamenu_backarow").forEach(function(e){
  e.addEventListener("click",function(){
    this.parentElement.parentElement.parentElement.parentElement.classList.remove("active");
    this.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove("subdrawer-active");
  });
});

function toggleFilter(classname){
  document.querySelector(classname).addEventListener("click",function(e){
    e.preventDefault(), e.stopImmediatePropagation();
    this.classList.toggle("active");
  });
}

if(document.querySelector(".filter-box h4") != null){
  toggleFilter(".filter-box h4");
}

if(document.querySelector(".filter-sort") != null){
  var ONloadVlau = document.querySelector(".filter-sort ul li.active").querySelector("label .label_span_val").innerHTML;
  document.querySelector(".sorting_value").innerHTML = ONloadVlau;
  document.querySelectorAll("input[name='sort_by']+label").forEach(function(e){
    e.addEventListener("click",function(event){
      var Value = e.querySelector(".label_span_val").innerHTML;
      document.querySelector(".sorting_value").innerHTML = Value;
    })
  })
}

if(document.querySelector(".brand_filter_search") != null){
  document.querySelector(".brand_filter_search .filter-search-input").addEventListener("keypress",function(e){
    setTimeout(function(){
      var NextInput = e.target.parentElement.parentElement.nextElementSibling.querySelectorAll("li");
      var SearchValue = e.target.value.toLowerCase();
      var key = e.which || e.keyCode || e.charCode;
      NextInput.forEach(function(event){
        var FilterValue = event.querySelector("input").dataset.filtervalue;
        if (FilterValue.indexOf(SearchValue) > -1) {
          event.style.display = "block";
        } else {
          event.style.display = "none";
        }
      })
    }, 0);
  });
  document.querySelector(".brand_filter_search .filter-search-input").addEventListener("keydown",function(e){
    var key = event.keyCode || event.charCode;
    var NextLi = e.target.parentElement.parentElement.nextElementSibling.querySelectorAll("li");
    setTimeout(function(){
      if(key == 8 || key == 46){
        if(e.target.value == ""){
          NextLi.forEach(function(event){
            event.style.display="block"
          })
        }
      }
    }, 0);
  });
}

function completeTheLook(){
  var LookSLider=[];
  document.querySelectorAll('.complete-the-look-swiper').forEach(function(Element,index){
    let productid = Element.dataset.id;
    let outer_carousel = Element.closest('.complete-the-look-main-slider');
    let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
    let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
    let swiperObject={
      loop:eval(Element.dataset.loop),
      slidesPerView: "auto",
      navigation: {
        nextEl:nextbutton,
        prevEl:prevbutton,
      },
    };    
    LookSLider[productid]=new Swiper(Element,swiperObject);
  });
}
completeTheLook();

var size_chart_btn = document.querySelector(".choose-selector a");
if(size_chart_btn != null){
  size_chart_btn.addEventListener("click",function(e){
    e.preventDefault();
    this.parentElement.parentElement.parentElement.parentElement.querySelector(".size-chart-main-div").classList.add("active")
    document.body.classList.add("size-chart-open");
  });
  
  document.body.addEventListener("click", function (evt) {
    var match_body_div = document.querySelector("body.size-chart-open");
    var match_size_chart = document.querySelector("body.size-guid-open");
    if(evt.target == match_body_div){
      document.querySelector(".size-chart-main-div").classList.remove("active")
      document.body.classList.remove("size-chart-open");
    }
    if(evt.target == match_size_chart){
      document.querySelector(".size-guild-message").classList.remove("active");
      document.body.classList.remove("size-guid-open");
    }
  });

  var closeBTN = document.querySelector(".size-chart-close-btn");
  closeBTN.addEventListener("click",function(){
    this.parentElement.parentElement.parentElement.classList.remove("active");
    document.body.classList.remove("size-chart-open");
  });

  var save_variant_btn = document.querySelectorAll(".save-variant-button");
  save_variant_btn.forEach(function(evtt){
    evtt.addEventListener("click",function(){
      this.parentElement.parentElement.parentElement.classList.remove("active");
      document.body.classList.remove("size-chart-open");
    })
  })
  
  var all_variants = document.querySelectorAll(".pro-labelinr.fourkids-vendor");
  all_variants.forEach(function(variant){
    variant.addEventListener("click",function(){
      var addToCartButtons = document.querySelectorAll('.button.product-addcart.button-2');
      if(this.classList.contains('sold-out-variant')){
        if(window.innerWidth < 576){
          var sizeChartParent = document.querySelector(".size-chart-parent-var.active");
          if(sizeChartParent){
            sizeChartParent.classList.remove("active");
            var blackOverlay = document.querySelector(".black-overlay-mobile");
            if(blackOverlay){
              blackOverlay.style.display = "none";
            }
            checkIfActive();
            document.querySelectorAll(".save-variant-button")[2].style.display="block";
            document.querySelector(".show-add-to-cart-button").style.display="none";
            setTimeout(function() {
              var voyadoContainer = document.querySelector(".voyado-bis-secondary-container");
              if(voyadoContainer){
                voyadoContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            }, 100);
          }
        } else {
          var sizeChart = document.querySelector(".size-chart-main-div.active");
          if(sizeChart){
            sizeChart.classList.remove("active");
            document.body.classList.remove("size-chart-open");
          }
        }
        addToCartButtons.forEach(function(button) {
          button.disabled = true;
          var buttonSpan = button.querySelector('span');
          if (buttonSpan) buttonSpan.innerHTML = 'Sold out';
          button.classList.add('sold-out');
        });
      } else {
        addToCartButtons.forEach(function(button) {
          button.disabled = false;
          var buttonSpan = button.querySelector('span');
          if (buttonSpan) buttonSpan.innerHTML = 'Add to cart';
          button.classList.remove('sold-out');
        });
      }
    })
  })
}

if(document.querySelector(".size_chart_btn")){
  document.querySelector(".size_chart_btn").addEventListener("click",function(){
    document.querySelector(".size-guild-message").classList.add("active");
    document.body.classList.add("size-guid-open");
  });
  document.querySelector(".size_guild_close").addEventListener("click",function(){
    document.querySelector(".size-guild-message").classList.remove("active");
    document.body.classList.remove("size-guid-open");
  });
  document.querySelector(".mobile-select-size-variants .size-chart-title").addEventListener("click",function(){
    document.querySelector(".size-guild-message").classList.add("active");
    document.body.classList.add("size-guid-open");
  });
}

const show_filter = () => {
  const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
  const body = document.body;
  body.style.position = 'fixed';
  body.style.top = `-${scrollY}px`;
};

const close_filter = () => {
  const body = document.body;
  const scrollY = body.style.top;
  body.style.position = '';
  body.style.top = '';
  window.scrollTo(0, parseInt(scrollY || '0') * -1);
}

if(document.querySelector(".sort-filter-fro-mobile") != null){
  document.querySelector(".sort-filter-fro-mobile").addEventListener("click",function(event){
    event.preventDefault(), event.stopImmediatePropagation();
    this.parentElement.nextElementSibling.querySelector(".collection_filters_main").classList.add("active");
    document.querySelector('body').classList.add('open-filter-popup');
    if(document.querySelector('body').classList.contains('open-filter-popup')){
      show_filter()
    }
  });
}

if(document.querySelector(".back-filter-icon") != null){
  var Back_filter_btn = document.querySelectorAll(".back-filter-icon");
  Back_filter_btn.forEach(function(e){
    e.addEventListener("click",function(event){
      event.preventDefault(), event.stopImmediatePropagation();
      this.parentElement.parentElement.parentElement.classList.remove("active")
    })    
  })
}

if(window.innerWidth > 576){
  if(document.querySelector(".snippet-addto-cart .choose-selector")){
    var Hide_cart_button = document.querySelector(".snippet-addto-cart .choose-selector"); 
    Hide_cart_button.classList.remove("hide-selectore-button");
  }
  if(document.querySelectorAll(".variant-row-list input[name*='Size'], .variant-row-list input[name*='Title']").length > 0){
    document.querySelectorAll(".variant-row-list input[name*='Size'], .variant-row-list input[name*='Title']").forEach(function(e){
      var ValueLIMITdesk
      e.addEventListener("change",function(){
        ValueLIMITdesk = this.value;
        document.querySelector(".slider_add_to_Cart .product-addcart .desktop_selected_size").classList.add("active");
        document.querySelector(".slider_add_to_Cart .product-addcart .desktop_selected_size").innerHTML = ValueLIMITdesk;
      })
    });
  }
  if(document.querySelector(".variant-row-list input[name*='Size']:checked, .variant-row-list input[name*='Title']:checked")){
    var CHecked_value = document.querySelector(".variant-row-list input[name*='Size']:checked, .variant-row-list input[name*='Title']:checked").value;
    document.querySelector(".slider_add_to_Cart .product-addcart .desktop_selected_size").classList.add("active");
    document.querySelector(".slider_add_to_Cart .product-addcart .desktop_selected_size").innerHTML = CHecked_value;
  }
}

const checkIfActive = () => {
  if (document.querySelector(".size-chart-parent-var").classList.contains("active")) {
    if(window.innerWidth < 576){
      document.documentElement.classList.add("overflow-hidden");
    }
  } else {
    if(window.innerWidth < 576){
      document.documentElement.classList.remove("overflow-hidden");
    }
  }
};

if(window.innerWidth < 576){
  document.querySelectorAll(".mobile-select-size-variants input[name='Size'], .mobile-select-size-variants input[name='Title'], .mobile-select-size-variants input[name='Shoe Size'], .mobile-select-size-variants input[name='Day']").forEach(function(e){
    e.addEventListener("change",function(){
      var ValueLIMIT = this.value;
      document.querySelector(".product-variant-name").innerHTML = ValueLIMIT;
      console.log("working")
      if(this.getAttribute("data-value") != 0){
        document.querySelectorAll(".save-variant-button")[2].style.display="none";
        document.querySelector(".show-add-to-cart-button").style.display="block";
      } else {
        document.querySelector(".show-add-to-cart-button").style.display="none";
        document.querySelectorAll(".save-variant-button")[2].style.display="block";
      }
    })
  });

  const pathnameSegments = window.location.pathname.split('/');
  const productsIndex = pathnameSegments.indexOf('products');
  let productHandle;
  if (productsIndex !== -1 && productsIndex < pathnameSegments.length - 1) {
    productHandle = pathnameSegments[productsIndex + 1];
  }

  if (productHandle) {
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        if(document.querySelectorAll(".save-variant-button")[2]){
          document.querySelectorAll(".save-variant-button")[2].addEventListener("click", function(){
            let selectedVariant = document.querySelector(".mobile-select-size-variants input[name='Size']:checked, .mobile-select-size-variants input[name='Title']:checked, .mobile-select-size-variants input[name='Shoe Size']:checked, .mobile-select-size-variants input[name='Day']:checked");
            if(selectedVariant){
              let dataValue = parseInt(selectedVariant.getAttribute("data-value"), 10); 
              if(dataValue > 0){
                document.querySelectorAll(".save-variant-button")[2].style.display="none";
                document.querySelector(".show-add-to-cart-button").style.display="block";
                document.querySelector(".product-variant-name").innerHTML = selectedVariant.value;
              }
            }
            if(window.innerWidth < 576){
              var winHeight = window.screen.height;
              var getScrollTop = window.pageYOffset || document.documentElement.scrollTop;
              var FixedTopPosition = '-'+getScrollTop+'px';
              document.documentElement.setAttribute("data-scroll",getScrollTop);
              document.documentElement.style.top=FixedTopPosition;
              document.querySelector(".size-chart-parent-var").style.maxHeight=`calc(${winHeight}px - 218px)`;
            }
            if (product.options[0].values.length > 1) {
              const blackOverlayMobile = document.querySelector(".black-overlay-mobile");
              if(blackOverlayMobile) blackOverlayMobile.style.display="block";
              document.querySelector(".size-chart-parent-var").classList.add("active");
              checkIfActive();
              document.querySelector(".mobile-select-size-variants").classList.add("active");
            } else if (product.options[0].values.length <= 1) {
            } else {
              const blackOverlayMobile = document.querySelector(".black-overlay-mobile");
              if(blackOverlayMobile) blackOverlayMobile.style.display="block";
              document.querySelector(".size-chart-parent-var").classList.add("active");
              checkIfActive();
              document.querySelector(".mobile-select-size-variants").classList.add("active");
            }
          });

          document.querySelectorAll(".save-variant-button")[0].addEventListener("click",function(){
            if (document.querySelector(".mobile-select-size-variants input[name='Size']:checked, .mobile-select-size-variants input[name='Title']:checked, .mobile-select-size-variants input[name='Shoe Size']:checked, .mobile-select-size-variants input[name='Day']:checked")) {
              if (document.querySelector(".mobile-select-size-variants input[name='Size']:checked, .mobile-select-size-variants input[name='Title']:checked, .mobile-select-size-variants input[name='Shoe Size']:checked, .mobile-select-size-variants input[name='Day']:checked").getAttribute("data-value") != 0) {
                document.querySelectorAll(".save-variant-button")[2].style.display="none";
                document.querySelector(".show-add-to-cart-button").style.display="block";
                document.querySelector(".product-variant-name").innerHTML = document.querySelector(".mobile-select-size-variants input[name='Size']:checked, .mobile-select-size-variants input[name='Title']:checked, .mobile-select-size-variants input[name='Shoe Size']:checked, .mobile-select-size-variants input[name='Day']:checked").value;
              }
            }
            if (product.options[0].values.length > 1) {
              document.querySelector(".size-chart-parent-var").classList.add("active");
              checkIfActive();
            } else if (product.options[0].values.length <= 1) {
            } else {
              document.querySelector(".size-chart-parent-var").classList.add("active");
              checkIfActive();
            }
          });
        }
      })
      .catch(err => console.error('Error fetching product:', err));
  }

  document.querySelector("body").addEventListener("click",function(e){
    const blackOverlayMobile = document.querySelector(".black-overlay-mobile");
    if(e.target == blackOverlayMobile){
      if(blackOverlayMobile) blackOverlayMobile.style.display="none";
      document.querySelector(".size-chart-parent-var").classList.remove("active");
      checkIfActive();
      document.querySelectorAll(".save-variant-button")[2].style.display="block";
      document.querySelector(".show-add-to-cart-button").style.display="none";
      document.querySelector(".mobile-select-size-variants").classList.remove("active");
      if(window.innerWidth < 576){
        if(blackOverlayMobile) blackOverlayMobile.style.display="none";
        var ScrollPosition = Number(document.documentElement.getAttribute("data-scroll"));
        window.scrollTo({ top: ScrollPosition, behavior: 'auto' });
      }
    }
  });

  if(document.querySelector(".mobile_size_close")) document.querySelector(".mobile_size_close").addEventListener("click",function(){
    const blackOverlayMobile = document.querySelector(".black-overlay-mobile");
    document.querySelector(".size-chart-parent-var").classList.remove("active");
    checkIfActive();
    document.querySelectorAll(".save-variant-button")[2].style.display="block";
    document.querySelector(".show-add-to-cart-button").style.display="none";
    document.querySelector(".mobile-select-size-variants").classList.remove("active");
    if(blackOverlayMobile) blackOverlayMobile.style.display="none";
    var ScrollPosition = Number(document.documentElement.getAttribute("data-scroll"));
    window.scrollTo({ top: ScrollPosition, behavior: 'auto' });
  })
}

if(document.querySelector(".specificaion-discri")){
  var Specification_height = document.querySelector(".specificaion-discri").clientHeight+"px";
  document.querySelector(".product-specification .specificaion-discri").style.height = Specification_height;
  document.querySelector(".product-specification h5").addEventListener("click",function(){
    this.parentElement.classList.toggle("close");
  });
}

if(document.querySelector(".facet-list.filter-index.active")){
  document.querySelector(".facet-list.filter-index.active").classList.remove("active");
}

if(document.querySelector(".show_more_filter")){
  document.querySelector(".show_more_filter").addEventListener("click",function(){
    this.parentElement.nextElementSibling.classList.toggle("active");
    this.classList.toggle("active");
  })
}

function collectionscroll(){
  var TOPTOP = document.querySelector(".sorting-button-formobile").offsetTop;
  document.addEventListener('scroll',function(){
    if(document.documentElement.scrollTop > TOPTOP){
      document.querySelector(".sorting-button-formobile").classList.add("sticky-collection")
      document.querySelector(".sticky-collection").querySelector(".sort-filter-fro-mobile").classList.remove("Button-1")
    } else {
      document.querySelector(".sorting-button-formobile").classList.remove("sticky-collection")
      document.querySelector(".sorting-button-formobile").querySelector(".sort-filter-fro-mobile").classList.add("Button-1")
    }
  });
}

if(document.querySelector(".sorting-button-formobile") && document.querySelector(".raffel-collection-filter-btn-mobile") == null){
  collectionscroll();
}

if(window.innerWidth > 991){
  if(document.querySelectorAll(".choose-selector a")[0] && document.querySelector(".Product-recomndation-section-pdp")){
    productAddCart();
    Remove_StickyClass();
  }
}

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const isNotCombinedKey = !(event.ctrlKey || event.altKey || event.shiftKey);
    if (isNotCombinedKey) {
      if(document.querySelector(".size-chart-main-div.active")){
        document.querySelector(".size-chart-main-div.active").classList.remove("active"); 
        document.body.classList.remove("size-chart-open");
      }
      if(document.querySelector(".size-guild-message.active")){
        document.querySelector(".size-guild-message").classList.remove("active");
        document.body.classList.remove("size-guid-open");
      }
    }
    if(document.body.classList.contains("predective-search-active")){
      document.body.classList.remove("predective-search-active");
      document.getElementById("predictive-search").style.display="none";
    }
  }
});

document.body.addEventListener("click",function(evt){
  if(document.body.classList.contains("predective-search-active")){
    document.body.classList.remove("predective-search-active");
    document.getElementById("predictive-search").style.display="none";
  }
})

if(document.querySelector(".mobile-select-size-variants")){
  var product_section_footer = document.querySelector("#shopify-section-footer").offsetTop + 200;
  document.addEventListener('scroll',function(){
    if(document.documentElement.scrollTop > product_section_footer){
      document.querySelector(".mobile-select-size-variants").style.position= "inherit";
    } else {
      document.querySelector(".mobile-select-size-variants").style.position= "fixed";
    }
  });
}

function swymCallbackFn(swat) {
  swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function(event) {
    document.querySelector(".wish_list_message .remove_message").style.display = "none";
    document.querySelector(".wish_list_message .add_message").style.display = "inline-block";
    document.querySelector(".wish_list_message").style.display = "block";
    setTimeout(function(){
      document.querySelector(".wish_list_message").style.display = "none";
    }, 2000);
  });
  swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, function(event) {
    document.querySelector(".wish_list_message .remove_message").style.display = "inline-block";
    document.querySelector(".wish_list_message .add_message").style.display = "none";
    document.querySelector(".wish_list_message").style.display = "block";
    setTimeout(function(){
      document.querySelector(".wish_list_message").style.display = "none";
    }, 2000);
  });
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

class LanguageSwitcher {
  constructor() {
    this.wrapper = document.querySelector('.language-wrapper');
    this.button = document.querySelector('.language-switcher');
    this.form = document.querySelector('.language-form');
    this.list = document.getElementById('LanguageList');
    this.hiddenInput = document.getElementById('LocaleCode');
    if (!this.wrapper || !this.button || !this.form) return;
    this.init();
  }
  
  init() {
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown();
    });
    if (this.list) {
      const languageLinks = this.list.querySelectorAll('.language-option');
      languageLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.selectLanguage(link.dataset.value);
        });
      });
    }
    document.addEventListener('click', (e) => {
      if (!this.wrapper.contains(e.target)) {
        this.closeDropdown();
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.wrapper.classList.contains('open')) {
        this.closeDropdown();
        this.button.focus();
      }
    });
    if (this.list) {
      this.setupKeyboardNavigation();
    }
  }
  
  toggleDropdown() {
    const isOpen = this.wrapper.classList.contains('open');
    if (isOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }
  
  openDropdown() {
    this.wrapper.classList.add('open');
    this.button.setAttribute('aria-expanded', 'true');
    if (this.list) {
      const firstLink = this.list.querySelector('.language-option');
      if (firstLink) {
        setTimeout(() => firstLink.focus(), 100);
      }
    }
  }
  
  closeDropdown() {
    this.wrapper.classList.remove('open');
    this.button.setAttribute('aria-expanded', 'false');
  }
  
  selectLanguage(localeCode) {
    if (!this.hiddenInput || !this.form) return;
    const currentLocale = this.hiddenInput.value;
    if (localeCode === currentLocale) {
      this.closeDropdown();
      this.button.focus();
      return;
    }
    this.hiddenInput.value = localeCode;
    this.form.submit();
  }
  
  setupKeyboardNavigation() {
    const languageLinks = Array.from(this.list.querySelectorAll('.language-option'));
    languageLinks.forEach((link, index) => {
      link.addEventListener('keydown', (e) => {
        let targetIndex;
        switch(e.key) {
          case 'ArrowDown':
            e.preventDefault();
            targetIndex = (index + 1) % languageLinks.length;
            languageLinks[targetIndex].focus();
            break;
          case 'ArrowUp':
            e.preventDefault();
            targetIndex = (index - 1 + languageLinks.length) % languageLinks.length;
            languageLinks[targetIndex].focus();
            break;
          case 'Home':
            e.preventDefault();
            languageLinks[0].focus();
            break;
          case 'End':
            e.preventDefault();
            languageLinks[languageLinks.length - 1].focus();
            break;
          case 'Enter':
          case ' ':
            e.preventDefault();
            link.click();
            break;
        }
      });
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new LanguageSwitcher();
    if (window.innerWidth < 992) {
      initMobileLanguageSwitcher();
    }
  });
} else {
  new LanguageSwitcher();
  if (window.innerWidth < 992) {
    initMobileLanguageSwitcher();
  }
}

function initMobileLanguageSwitcher() {
  const mobileForm = document.querySelector('.mobile-language-form');
  const mobileList = document.querySelector('.mobile-language-list');
  const mobileHiddenInput = document.getElementById('MobileLocaleCode');
  const mobileLinks = document.querySelectorAll('.mobile-language-link');
  const activeLink = document.querySelector('.mobile-language-link.active');
  if (!mobileForm || !mobileHiddenInput || !mobileLinks.length) return;
  if (activeLink && mobileList) {
    activeLink.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      mobileList.classList.toggle('expanded');
    });
    document.addEventListener('click', (e) => {
      if (!mobileList.contains(e.target)) {
        mobileList.classList.remove('expanded');
      }
    });
  }
  mobileLinks.forEach(link => {
    if (!link.classList.contains('active')) {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const localeCode = link.dataset.value;
        const currentLocale = mobileHiddenInput.value;
        if (localeCode === currentLocale) return;
        mobileHiddenInput.value = localeCode;
        mobileForm.submit();
      });
    }
  });
}

window.addEventListener('popstate', function () {
  document.body.classList.remove('active-megamenu');
});

window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    document.body.classList.remove('active-megamenu');
  }
});

// ======= FOURKIDS: Sold-out variant notify me =======
(function() {
  function initNotifyMe() {
    document.querySelectorAll('.notify-me_buton').forEach(function(btn) {
      if (btn.dataset.notifyBound) return;
      btn.dataset.notifyBound = 'true';

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Close the desktop drawer
        var sizeChartDiv = document.querySelector('.size-chart-main-div.active');
        if (sizeChartDiv) {
          sizeChartDiv.classList.remove('active');
          document.body.classList.remove('size-chart-open');
        }

        // Close mobile panel
        var sizeChartParent = document.querySelector('.size-chart-parent-var.active');
        if (sizeChartParent) {
          sizeChartParent.classList.remove('active');
          var blackOverlay = document.querySelector('.black-overlay-mobile');
          if (blackOverlay) blackOverlay.style.display = 'none';
        }

        // Scroll to Voyado form - try multiple selectors
        var voyado = document.querySelector('#voyado_engage_app_block_bis_WVcnbp')
          || document.querySelector('[id*="voyado_engage"]')
          || document.querySelector('[id*="voyado"]')
          || document.querySelector('.voyado-bis-form-container')
          || document.querySelector('.voyado-bis-secondary-container')
          || document.querySelector('[class*="voyado-bis"]');

        if (voyado) {
          var headerHeight = document.querySelector('.section-header')
            ? document.querySelector('.section-header').clientHeight
            : 0;
          var top = voyado.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
          window.scrollTo({ top: top, behavior: 'smooth' });
          setTimeout(function() {
            var input = voyado.querySelector('input[type="email"]');
            if (input) input.focus();
          }, 600);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNotifyMe);
  } else {
    initNotifyMe();
  }

  var observer = new MutationObserver(function() {
    initNotifyMe();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
// ======= END FOURKIDS notify me =======